module.exports = __webpack_public_path__ + "static/media/CAN.1dc4cd23.jpg";